import { call, put } from 'redux-saga/effects';
import { requestGetRunningTimer, requestGetRunningTimers, requestGetRunningTimerByUser, requestGetTimers, requestGetTimeRecordsByUser, requestGetTimeByUserTotal, requestGetTimeProfile, requestGetClientsWithRecentActivity, requestCreateTime, requestUpdateTime, requestDeleteTime, requestRestoreTime } from '../requests/time';
import { showAlert } from '../../slices/alerts';
import { safeErrorMessage } from '../../../utils/errorUtils';

export function* handleGetRunningTimer(action) {
    try {
        const { callback } = action.payload;
        const response = yield call(requestGetRunningTimer);
        if (callback) {
            callback(response.data);
        }
    } catch (error) {
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
    }
}

export function* handleGetRunningTimers(action) {
    try {
        const { callback } = action.payload;
        const response = yield call(requestGetRunningTimers);
        if (callback) {
            callback(response.data);
        }
    } catch (error) {
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
    }
}

export function* handleGetRunningTimerByUser(action) {  
    try {
        const { userId, callback } = action.payload;
        const response = yield call(requestGetRunningTimerByUser, userId);
        if (callback) {
            callback(response.data);
        }
    } catch (error) {
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
    }
}

export function* handleGetTimers(action) {
    try {
        const { parentType, parentId, callback } = action.payload;
        const response = yield call(requestGetTimers, parentType, parentId);
        if (callback) {
            callback(response.data);
        }
    } catch (error) {
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
    }
}

export function* handleGetTimeRecordsByUser(action) {
    try {
        const { userId, startDate, endDate, callback } = action.payload;
        const response = yield call(requestGetTimeRecordsByUser, userId, startDate, endDate);
        if (callback) {
            callback(response.data);
        }
    } catch (error) {
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
    }
}

export function* handleGetTimeByUserTotal(action) {
    try {
        const { userId, startDate, endDate, callback } = action.payload;
        const response = yield call(requestGetTimeByUserTotal, userId, startDate, endDate);
        if (callback) {
            callback(response.data);
        }
    } catch (error) {
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
    }
}

export function* handleGetTimeProfile(action) {
    try {
        const { userId, callback } = action.payload;
        const response = yield call(requestGetTimeProfile, userId);
        if (callback) {
            callback(response.data);
        }
    } catch (error) {
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
    }
}

export function* handleCreateTime(action) {
    try {
        const { parentType, parentId, data, callback } = action.payload;
        const response = yield call(requestCreateTime, parentType, parentId, data);
        if (callback) {
            callback(response.data);
        }
    } catch (error) {
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
        if (action.payload.callback) action.payload.callback(null);
    }
}

export function* handleUpdateTime(action) {
    try {
        const { timeId, data, callback } = action.payload;
        const response = yield call(requestUpdateTime, timeId, data);
        if (callback) {
            callback(response.data);
        }
    } catch (error) {
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
    }
}

export function* handleDeleteTime(action) {
    try {
        const { timeId, callback } = action.payload;
        const response = yield call(requestDeleteTime, timeId);
        if (callback) {
            callback(response.data);
        }
    } catch (error) {
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
    }
}

export function* handleRestoreTime(action) {
    try {
        const { timeId, callback } = action.payload;
        const response = yield call(requestRestoreTime, timeId);
        if (callback) {
            callback(response.data);
        }
    } catch (error) {
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
    }
}

export function* handleGetClientsWithRecentActivity(action) {
    try {
        const { callback } = action.payload;
        const response = yield call(requestGetClientsWithRecentActivity);
        if (callback) {
            callback(response.data);
        }
    } catch (error) {
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
    }
}